import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
export const contentWrapperContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    grid_template_columns: 'repeat(12, 1fr)',
    display: 'grid',
    width: '100%',
    max_width: '1440px',
    gap: FOUNDATIONS.spacing_300,
    padding: `0 ${FOUNDATIONS.spacing_300}`,
    margin: 'auto',
    [DeviceBreakpointsType.TABLET]: {
        display: 'block',
        margin: FOUNDATIONS.spacing_00,
        gap: FOUNDATIONS.spacing_00,
        padding: FOUNDATIONS.spacing_00,
    },
    [DeviceBreakpointsType.MOBILE]: {
        display: 'block',
        margin: FOUNDATIONS.spacing_00,
        gap: FOUNDATIONS.spacing_00,
        padding: FOUNDATIONS.spacing_00,
    },
});
//# sourceMappingURL=commonStyles.js.map